/* Get all actions */
export const ACTIONS_COMPLAINTS_LIST_REQUEST = "ACTIONS_COMPLAINTS_LIST_REQUEST";
export const ACTIONS_COMPLAINTS_LIST_SUCCESS = "ACTIONS_COMPLAINTS_LIST_SUCCESS";
export const ACTIONS_COMPLAINTS_LIST_FAIL = "ACTIONS_COMPLAINTS_LIST_FAIL";
export const ACTIONS_COMPLAINTS_LIST_RESET = "ACTIONS_COMPLAINTS_LIST_RESET";

/* Get actions by complaint */
export const ACTIONS_COMPLAINT_LIST_REQUEST = "ACTIONS_COMPLAINT_LIST_REQUEST";
export const ACTIONS_COMPLAINT_LIST_SUCCESS = "ACTIONS_COMPLAINT_LIST_SUCCESS";
export const ACTIONS_COMPLAINT_LIST_FAIL = "ACTIONS_COMPLAINT_LIST_FAIL";
export const ACTIONS_COMPLAINT_LIST_RESET = "ACTIONS_COMPLAINT_LIST_RESET";

/* Get actions by complaint user view*/
export const ACTIONS_COMPLAINT_USER_LIST_REQUEST = "ACTIONS_COMPLAINT_USER_LIST_REQUEST";
export const ACTIONS_COMPLAINT_USER_LIST_SUCCESS = "ACTIONS_COMPLAINT_USER_LIST_SUCCESS";
export const ACTIONS_COMPLAINT_USER_LIST_FAIL = "ACTIONS_COMPLAINT_USER_LIST_FAIL";
export const ACTIONS_COMPLAINT_USER_LIST_RESET = "ACTIONS_COMPLAINT_USER_LIST_RESET";

export const ACTIONS_COMPLAINT_DETAILS_REQUEST = "ACTIONS_COMPLAINT_DETAILS_REQUEST";
export const ACTIONS_COMPLAINT_DETAILS_SUCCESS = "ACTIONS_COMPLAINT_DETAILS_SUCCESS";
export const ACTIONS_COMPLAINT_DETAILS_FAIL = "ACTIONS_COMPLAINT_DETAILS_FAIL";
export const ACTIONS_COMPLAINT_DETAILS_RESET = "ACTIONS_COMPLAINT_DETAILS_RESET";

export const ACTIONS_COMPLAINT_DELETE_REQUEST = "ACTIONS_COMPLAINT_DELETE_REQUEST";
export const ACTIONS_COMPLAINT_DELETE_SUCCESS = "ACTIONS_COMPLAINT_DELETE_SUCCESS";
export const ACTIONS_COMPLAINT_DELETE_FAIL = "ACTIONS_COMPLAINT_DELETE_FAIL";
export const ACTIONS_COMPLAINT_DELETE_RESET = "ACTIONS_COMPLAINT_DELETE_FAIL";

export const ACTIONS_COMPLAINT_UPDATE_REQUEST = "ACTIONS_COMPLAINT_UPDATE_REQUEST";
export const ACTIONS_COMPLAINT_UPDATE_SUCCESS = "ACTIONS_COMPLAINT_UPDATE_SUCCESS";
export const ACTIONS_COMPLAINT_UPDATE_FAIL = "ACTIONS_COMPLAINT_UPDATE_FAIL";
export const ACTIONS_COMPLAINT_UPDATE_RESET = "ACTIONS_COMPLAINT_UPDATE_RESET";

export const ACTIONS_COMPLAINT_ADD_REQUEST = "ACTIONS_COMPLAINT_ADD_REQUEST";
export const ACTIONS_COMPLAINT_ADD_SUCCESS = "ACTIONS_COMPLAINT_ADD_SUCCESS";
export const ACTIONS_COMPLAINT_ADD_FAIL = "ACTIONS_COMPLAINT_ADD_FAIL";
export const ACTIONS_COMPLAINT_ADD_RESET = "ACTIONS_COMPLAINT_ADD_RESET";

export const ACTIONS_COMPLAINT_DELETE_FILE_REQUEST = "ACTIONS_COMPLAINT_DELETE_FILE_REQUEST";
export const ACTIONS_COMPLAINT_DELETE_FILE_SUCCESS = "ACTIONS_COMPLAINT_DELETE_FILE_SUCCESS";
export const ACTIONS_COMPLAINT_DELETE_FILE_FAIL = "ACTIONS_COMPLAINT_DELETE_FILE_FAIL";
export const ACTIONS_COMPLAINT_DELETE_FILE_RESET = "ACTIONS_COMPLAINT_DELETE_FILE_RESET";
